<template>
  <ul class="chat-container" @click="$emit('button')">
    <li class="message-unread">
      <div class="notification-event row px-2 m-0">
          <div class="d-flex w-100 justify-content-between">
            <div class="d-flex name-container">
              <div class="author-thumb usr-thumb">
                <SUserAvatar
                  :myUser="lastMsgSender"
                  size="small"
                  :isProfileAvatar="false"
                />
              </div>
              <p class="h6 notification-friend">{{
                getUserName(lastMsgSender)
              }}</p>
            </div>
            <div class="">
              <span class="notification-date">
                <time class="entry-date updated">{{
                  getLastMsgTimeStamp(message.messages) | date
                }}</time>
              </span>
            </div>
          </div>
        <div class="col col-12">
          <span class="chat-message-item text-break">{{ lastMsgText }}</span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";

export default {
  name: "ChatItemListDropdown",
  props: ["message"],
  mixins: [ChatHelperVue, UserHelperVue],
  components: {
    SUserAvatar,
  },
  data() {
    return {
      counter: 0,
    };
  },
  computed: {
    lastMsgText() {
      return this.getLastSenderMsg(this.message.messages);
    },
    lastMsgSender() {
      return this.message.messages[this.message.messages.length - 1].sender;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-status.online {
  left: unset;
  top: 25px;
}
.name-container {
  overflow: hidden;
}
.usr-img-thumb {
  height: 34px;
  width: 34px;
  display: table-cell;
}
.chat-container {
  transition: background-color 125ms ease;
  cursor: pointer;
  margin: 1rem 0;

  :hover {
    background-color: #e7e9ec;
  }
}
.notification-friend {
  text-overflow: ellipsis;
  margin-left: 4px;
  overflow: hidden;
  white-space: nowrap;
}
.notification-date {
  margin-left: unset !important;
}
.notification-event {
  max-width: unset;
  margin-left: 0.5rem;
}
.message-unread {
  transition: none !important;
}
.chat-message-item {
  opacity: 0.4;
  overflow: hidden;
  width: 205px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-bottom: 5px;
  padding-left: 1.8rem;
  text-align: left !important;
}
</style>
